import { Link, NavLink, Outlet } from "react-router-dom";

import { useBlulogContext } from "./context";

const NAV_LINK_CLASS = ({ isActive }: { isActive: boolean }) =>
  `blulog-nav-link${isActive ? " blulog-nav-link--active" : ""}`;

export function BlulogLayout() {
  const { lastExtraction } = useBlulogContext();

  return (
    <main className="blulog-layout">
      <Link to="/temperature" className="blulog-back-link" aria-label="Retour à la liste des fournisseurs">
        <span aria-hidden="true">←</span>
        Retour aux fournisseurs
      </Link>

      <header className="blulog-header">
        <div>
          <p className="blulog-breadcrumb">Température · Fournisseur</p>
          <h1>Blulog</h1>
          <p className="blulog-subtitle">
            Tableaux de bord pour le suivi des capteurs BluConsole et extraction des données sources.
          </p>
        </div>

        {lastExtraction ? (
          <div className="blulog-summary" role="status">
            <strong>Dernière extraction</strong>
            {lastExtraction.finishedAt ? (
              <span>
                {lastExtraction.finishedAt.toLocaleString("fr-FR", {
                  dateStyle: "short",
                  timeStyle: "short",
                })}
              </span>
            ) : null}
            {lastExtraction.processedIds.length ? (
              <span>{lastExtraction.processedIds.length} capteur(s) traité(s)</span>
            ) : null}
            {lastExtraction.message ? <span>{lastExtraction.message}</span> : null}
          </div>
        ) : null}
      </header>

      <nav className="blulog-nav" aria-label="Navigation Blulog">
        <NavLink to="dashboard" end className={NAV_LINK_CLASS}>
          Dashboard
        </NavLink>
        <NavLink to="refresh-data" end className={NAV_LINK_CLASS}>
          Rafraîchir les données
        </NavLink>
      </nav>

      <section className="blulog-content">
        <Outlet />
      </section>
    </main>
  );
}
